import { render, staticRenderFns } from "./pie_chart.vue?vue&type=template&id=6ceac96f"
import script from "./pie_chart.vue?vue&type=script&lang=js"
export * from "./pie_chart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports